<template>
  <div class="">
    <DataFetcher dataKey="categories">
      <template #any="{ refresh, loading, loadingError, data }">
        <div class="relative pt-4">
          <div
            class="w-full duration-300 overflow-auto scrollInvisible"
            @scroll="onceScrolled = true"
            ref="pubsScroll"
          >
            <div
              v-if="!loading && (loadingError || !Array.isArray(data))"
              class="flex items-center justify-center text-red-500 cursor-pointer absolute w-full h-full gap-2"
              @click="refresh"
            >
              <div class="font-bold text-lg">Categories non chargée</div>
              <div class="w-6 h-6">
                <ColorImg
                  src="/images/icons/load.png"
                  alt=""
                  class="bg-current"
                />
              </div>
            </div>
            <div
              class="w-max flex gap-4 px-8"
              :class="{
                'opacity-0 pointer-events-none':
                  !loading && (loadingError || !Array.isArray(data))
              }"
            >
              <div
                v-for="(category, id) in loading
                  ? [
                      { shimmer: true },
                      { shimmer: true },
                      { shimmer: true },
                      { shimmer: true },
                      { shimmer: true },
                      { shimmer: true },
                      { shimmer: true },
                      { shimmer: true },
                      { shimmer: true },
                      { shimmer: true },
                      { shimmer: true },
                      { shimmer: true },
                      { shimmer: true },
                      { shimmer: true }
                    ]
                  : loadingError || !Array.isArray(data)
                    ? [{ error: true }]
                    : data"
                class="flex relative flex-col items-center w-[15vw]"
                :class="{}"
                :key="id"
              >
                <div
                  @click="$emit('categoryClicked', category)"
                  class="w-full p-[50%] ripple rounded-3xl relative overflow-hidden border-0 shadow-sm"
                  :class="{
                    '!pointer-events-none shimmerElement': category.shimmer,
                    liquidGlassCard: !category.shimmer
                  }"
                >
                  <div
                    class="absolute w-full h-full top-0 left-0 flex items-center justify-center"
                  >
                    <ImgComponent
                      :src="
                        category.icon ||
                        category.iconUrl ||
                        category.imageUrl ||
                        '/images/categories/default.svg'
                      "
                      class="object-cover object-center w-full h-full"
                      alt=""
                    />
                  </div>
                </div>
                <div class="text-xs whitespace-nowrap">
                  {{ category.name }}
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="
              !onceScrolled && !loading && !loadingError && Array.isArray(data)
            "
            class="flex z-[2] absolute items-center justify-center duration-300 w-12 h-full top-1/2 -translate-y-1/2 cursor-pointer right-0"
            @click="
              () => {
                $refs.pubsScroll.scrollBy(
                  ($refs.pubsScroll.offsetWidth * 4) / 5,
                  0
                );
              }
            "
          >
            <div
              class="w-full h-full absolute top-0 left-0 opacity-0 group-hover:opacity-40 bg-[#f4f6f5] duration-300"
              style="
                mask-image: linear-gradient(to left, black 10%, transparent);
              "
            ></div>
            <div
              class="absolute w-8 h-8 rounded-full flex items-center justify-center"
            >
              <div
                class="absolute w-8 h-8 bg-slate-300/30 rounded-full animate-[ping2_10s_ease-in-out_infinite]"
              ></div>
              <div
                class="absolute w-full h-full bg-slate-300/30 rounded-full p-6 animate-[ping2_10s_ease-in-out_infinite]"
              ></div>
              <ImgComponent
                src="/images/all/angle-down-primary.svg"
                class="-rotate-90 w-full h-full relative bg-white rounded-full"
                alt=""
              />
            </div>
          </div>
        </div>
      </template>
    </DataFetcher>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const onceScrolled = ref(false);
</script>
